import { ReactNode } from 'react';

export function MetricCard({ label, value, icon, tone = 'blue' }: { label: string; value: string | number; icon?: ReactNode; tone?: 'blue' | 'green' | 'amber' | 'red' }) {
  const colors = {
    blue: 'bg-neon-blue/15 text-neon-blue',
    green: 'bg-mint/15 text-mint',
    amber: 'bg-amber/15 text-amber',
    red: 'bg-danger/15 text-red-300'
  };
  return (
    <div className="glass rounded-2xl p-4 shadow-neon">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-400">{label}</p>
        {icon ? <span className={`rounded-lg p-2 ${colors[tone]}`}>{icon}</span> : null}
      </div>
      <p className="mt-3 text-3xl font-bold tracking-normal text-white">{value}</p>
    </div>
  );
}
